import Image from "next/image";
import {
  CardContainerPeople,
  CardInfo,
  Name,
  Role,
  Excerpt,
  ImageContainerPeople,
} from "./styles";
import { imageLoader } from "@/lib/sanity/client";
import { useState } from "react";

export type PeopleProps = {
  variant: "people";
  name?: string;
  role?: string;
  excerpt?: string;
  image?: {
    asset?: Record<string, any>;
  };
};

const CardPeople: React.FC<PeopleProps> = (props) => {
  const { name, role, excerpt, image } = props;
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <CardContainerPeople>
      <ImageContainerPeople $isLoaded={isLoaded}>
        {image && image?.asset && image.asset?.url && (
          <Image
            sizes="(max-width: 768px) 75vw, 40vw"
            src={image.asset?.url}
            layout="fill"
            objectFit="cover"
            loader={imageLoader}
            onLoadingComplete={() => setIsLoaded(true)}
            alt=""
          />
        )}
      </ImageContainerPeople>
      <CardInfo>
        {name && <Name>{name}</Name>}
        {role && <Role>{role}</Role>}
        {excerpt && <Excerpt>“{excerpt}“</Excerpt>}
      </CardInfo>
    </CardContainerPeople>
  );
};

export default CardPeople;
